import { render, staticRenderFns } from "./CustomizeAddTopicPop.vue?vue&type=template&id=1ce8eaa8"
import script from "./CustomizeAddTopicPop.vue?vue&type=script&lang=js"
export * from "./CustomizeAddTopicPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports